<template>
  <layout-report-step
    :isDone="isDone"
    :title="header.title"
    :description="header.description"
    :image="header.image"
    :debug="header.debug"
  >
    <v-card class="pt-4 pr-4 pl-4" flat max-width="500">
      <v-form ref="form" v-model="valid" id="thgContact">
        <div class="ml-n7 mr-n7">
          <v-col cols="12">
            <v-card-title> {{ $t("report.reportContact.numberplate") }}</v-card-title>
            <v-card-text>
              <numberplate-form
                v-model="numberplate"
                :valid="numberplateValid"
                v-on:valid="numberplateValid = $event"
                :countryCode="countryCode"
              />
            </v-card-text>
          </v-col>
          <v-col cols="12" class="mb-n6">
            <v-card-title>
              {{ $t("components.profile.EditProfileDialog.general") }}
            </v-card-title>
            <v-card-subtitle>
              {{ $t("components.partner.PartnerBillingInformationDataDialog.question.company") }}
            </v-card-subtitle>
          </v-col>
          <v-card-text>
            <v-row class="mt-n4">
              <v-col cols="6" md="4">
                <v-radio-group v-model="isCompany" row>
                  <v-radio class="ml-3" :label="$t('components.profile.EditProfileDialog.private')" :value="false" />
                </v-radio-group>
              </v-col>
              <v-col cols="6" md="8">
                <v-radio-group v-model="isCompany" row>
                  <v-radio
                    :label="$t('components.profile.EditProfileDialog.company')"
                    :value="true"
                    data-test-form-iscompany
                  />
                </v-radio-group>
              </v-col>
            </v-row>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :label="$t('components.profile.EditProfileDialog.name')"
                :rules="[(v) => !!v || $t('components.profile.EditProfileDialog.mandatoryInput')]"
                v-model="firstName"
                data-test-profile-firstName
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :label="$t('components.profile.EditProfileDialog.lastname')"
                :rules="[(v) => !!v || $t('components.profile.EditProfileDialog.mandatoryInput')]"
                v-model="lastName"
                data-test-profile-lastName
              />
            </v-col>
          </v-card-text>

          <v-card-text v-if="isCompany">
            <v-col cols="12">
              <v-text-field
                :rules="[(v) => !!v || $t('components.profile.EditProfileDialog.mandatoryInput')]"
                class="mb-n6 mt-n7"
                outlined
                :label="$t('components.profile.EditProfileDialog.companyName') + ' *'"
                v-model="company"
                data-test-profile-company
              />
            </v-col>
          </v-card-text>

          <v-col cols="12">
            <v-card-title>
              {{ $t("components.profile.EditProfileDialog.taxInformation") }}
            </v-card-title>
            <v-card-subtitle>
              {{ $t("components.partner.PartnerBillingInformationDataDialog.question.tax") }}
            </v-card-subtitle>
          </v-col>

          <v-card-text>
            <v-row class="mt-n13 mb-n7">
              <v-col cols="6" md="4">
                <v-radio-group v-model="isTaxDeductible" row>
                  <v-radio class="ml-3" :label="$t('components.profile.EditProfileDialog.yes')" :value="true" />
                </v-radio-group>
              </v-col>
              <v-col cols="6" md="8">
                <v-radio-group v-model="isTaxDeductible" row>
                  <v-radio :label="$t('components.profile.EditProfileDialog.no')" :value="false" />
                </v-radio-group>
              </v-col>
            </v-row>
          </v-card-text>

          <div v-if="isTaxDeductible">
            <v-card-text>
              <v-col cols="12">
                <v-text-field
                  class="mt-n4 mb-n4"
                  outlined
                  :rules="taxNumberRules"
                  :label="`${$t('components.profile.EditProfileDialog.taxnumber')} *`"
                  v-model="taxnumber"
                  data-test-profile-taxnumber
                />
              </v-col>
            </v-card-text>
          </div>

          <v-col cols="12" class="mb-n6">
            <v-card-title>
              {{ $t("components.profile.EditProfileDialog.contactInformation") }}
            </v-card-title>
          </v-col>

          <v-card-text>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :label="`${$t('components.profile.EditProfileDialog.email')}`"
                :rules="emailRules"
                v-model="email"
                type="email"
                data-test-profile-email
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :label="`${$t('components.profile.EditProfileDialog.phone')}`"
                :rules="phoneNumberRules"
                v-model="phone"
                data-test-profile-phone
              />
            </v-col>
          </v-card-text>

          <v-col cols="12" class="mb-n6">
            <v-card-title> {{ $t("components.profile.EditProfileDialog.adress") }} </v-card-title>
          </v-col>

          <v-card-text>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :rules="addressRules"
                :label="`${$t('components.profile.EditProfileDialog.street')} *`"
                v-model="street"
                data-test-profile-street
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :rules="addressRules"
                :label="`${$t('components.profile.EditProfileDialog.zip')} *`"
                v-model="zip"
                data-test-profile-zip
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                class="mb-n6"
                outlined
                :rules="addressRules"
                :label="`${$t('components.profile.EditProfileDialog.city')} *`"
                v-model="city"
                data-test-profile-city
              />
            </v-col>
          </v-card-text>
        </div>
      </v-form>
    </v-card>
  </layout-report-step>
</template>

<script lang="ts">
import FileUploadMulti from "@/components/files/FileUploadMulti.vue";
import NumberplateForm from "@/components/utility/NumberplateForm.vue";
import LayoutReportStep from "@/layouts/LayoutReportStep.vue";
import { IReportHeaderData } from "@/lib/interfaces/Report/IReportHeaderData";
import { IReportStep } from "@/lib/interfaces/Report/IViewReportStep";
import { disallowUmlaut, emailRule, extendetPhoneRule } from "@/lib/rules/contactRule";
import { requiredRule } from "@/lib/rules/requiredRule";
import ReportStepMixin from "@/mixins/ReportStepMixin.vue";
import { ReportScreenEnum } from "@/store/enum/partner/report-screen.enum";
import { ReportModule } from "@/store/modules/report.store";
import { Component } from "vue-property-decorator";
import { UserModule } from "@/store/modules/me-user.store";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";

@Component({
  components: {
    LayoutReportStep,
    FileUploadMulti,
    NumberplateForm
  }
})
export default class ReportContact extends ReportStepMixin implements IReportStep {
  readonly screen = ReportScreenEnum.CONTACT;

  numberplateValid = false;

  valid = false;

  get header(): IReportHeaderData {
    return {
      title: "report.reportContact.title",
      description: "report.reportContact.description"
    };
  }

  get isTaxDeductible() {
    return ReportModule.isTaxDeductible;
  }

  set isTaxDeductible(value: boolean) {
    ReportModule.setIsTaxDeductible(value);
    if (!value) {
      ReportModule.setTaxnumber("");
    }
  }

  get isCompany() {
    return ReportModule.isCompany;
  }

  set isCompany(value: boolean) {
    ReportModule.setIsCompany(value);
    if (!value) {
      ReportModule.setCompanyName("");
    }
  }

  get countryCode(): CountryCodeEnum {
    return ReportModule.partnerCountryCode;
  }

  get numberplate() {
    return ReportModule.numberplate;
  }
  set numberplate(value: string) {
    ReportModule.setNumberplate(value);
  }

  get firstName() {
    return ReportModule.user.firstName;
  }
  set firstName(value: string) {
    ReportModule.setUser({
      firstName: value,
      lastName: this.lastName
    });
  }

  get lastName() {
    return ReportModule.user.lastName;
  }
  set lastName(value: string) {
    ReportModule.setUser({
      firstName: this.firstName,
      lastName: value
    });
  }

  get company() {
    return ReportModule.companyName;
  }
  set company(value: string) {
    ReportModule.setCompanyName(value);
  }

  get email() {
    return ReportModule.contact.email;
  }
  set email(value: string) {
    ReportModule.setContact({
      phone: this.phone,
      email: value
    });
  }

  get phone() {
    return ReportModule.contact.phone;
  }
  set phone(value: string) {
    ReportModule.setContact({
      phone: value,
      email: this.email
    });
  }

  get taxnumber() {
    return ReportModule.taxnumber;
  }
  set taxnumber(value: string) {
    ReportModule.setTaxnumber(value);
  }

  get street() {
    return ReportModule.address.street;
  }
  set street(value: string) {
    ReportModule.setAddress({
      street: value,
      zip: this.zip,
      city: this.city
    });
  }

  get zip() {
    return ReportModule.address.zip;
  }
  set zip(value: string) {
    ReportModule.setAddress({
      street: this.street,
      zip: value,
      city: this.city
    });
  }

  get city() {
    return ReportModule.address.city;
  }
  set city(value: string) {
    ReportModule.setAddress({
      street: this.street,
      zip: this.zip,
      city: value
    });
  }

  get emailRules() {
    const rules = [];

    rules.push(requiredRule());
    rules.push(emailRule());
    rules.push(disallowUmlaut());

    return rules;
  }

  get phoneNumberRules() {
    const rules = [];

    rules.push(extendetPhoneRule());

    return rules;
  }

  get addressRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  get isDone() {
    return this.valid && this.numberplateValid;
  }

  get requiredRule() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  get taxNumberRules() {
    const rules = [];

    rules.push(requiredRule());

    return rules;
  }

  mounted() {
    if (UserModule.user) {
      this.firstName = UserModule.user?.firstName ?? "";
      this.lastName = UserModule.user?.lastName ?? "";
      this.email = UserModule.user?.contact?.email ?? "";
      this.phone = UserModule.user?.contact?.phone ?? "";
      this.street = UserModule.user?.address?.street ?? "";
      this.zip = UserModule.user?.address?.zip ?? "";
      this.city = UserModule.user?.address?.city ?? "";
      this.isCompany = UserModule.user?.isCompany ?? false;
      this.isTaxDeductible = UserModule.user?.isTaxDeductible ?? false;
      this.company = UserModule.user?.company ?? "";
      this.taxnumber = UserModule.user?.taxnumber ?? "";
    }
  }
}
</script>
